import React, { Component } from 'react'
import styled from 'styled-components'

import CalendarCells from './CalendarCells'
import CalendarHeader from './CalendarHeader'
import WeekdayNames from './WeekdayNames'

const StyledCalendarContainer = styled.div`
  width: 100%;
  padding: 1em;
  max-width: 30em;
`

class Calendar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentMonth: this.props.currentMonth,
      selectedDates: this.props.selectedShifts,
      selectedWeek: null,
      cursor: null
    }
  }

  //if flexible shift is selected, update selectedShifts accordingly
  componentWillReceiveProps(nextProps) {
    this.setState({ selectedDates: nextProps.selectedShifts })
  }

  moveCursorTo = (date, week) => {
    const dateString = date.toDate().toDateString();
    const cursorDestination = dateString === this.state.cursor ? null : dateString
    this.setState(state => ({ 
        cursor: cursorDestination, 
        selectedWeek: this.handleSelectedWeek(state, date, week) 
      })
    )
  }

  handleDateClick = (selectedDate, selectedWeek) => {
    this.moveCursorTo(selectedDate);
    this.setState(
      state => ({
        selectedDates: this.handleSelectedDate(
          state,
          selectedDate,
          selectedWeek
        ),
        selectedWeek: this.handleSelectedWeek(state, selectedDate, selectedWeek)
      })
    )
  }

  handleSelectedDate = (prevState, selectedDate, selectedWeek) => {
    let remainingDates = this.state.selectedDates.filter(date => {
      return !selectedDate.isSame(date, 'day')
    });
    return (
      this.state.selectedDates.find(date => selectedDate.isSame(date, 'day')) //&& prevState.selectedWeek !== null
        ? remainingDates
        : [...this.state.selectedDates, selectedDate]
    )
  }

  handleSelectedWeek = (prevState, selectedDate, selectedWeek) =>
    this.state.cursor === selectedDate.toDate().toDateString() &&
      prevState.selectedWeek !== null
      ? null
      : selectedWeek

  nextMonth = () =>
    this.setState(
      {
        currentMonth: this.state.currentMonth.add(1, 'month'),
        selectedWeek: null
      },
      () => this.props.onChangeMonth(this.state.currentMonth)
    )

  prevMonth = () =>
    this.setState(
      {
        currentMonth: this.state.currentMonth.subtract(1, 'month'),
        selectedWeek: null
      },
      () => this.props.onChangeMonth(this.state.currentMonth)
    )

  render() {
    return (
      <StyledCalendarContainer>
        <CalendarHeader
          nextMonth={this.props.nextMonth}
          prevMonth={this.props.prevMonth}
          {...this.state}
        />
        <WeekdayNames />
        <CalendarCells
          handleDateClick={this.handleDateClick}
          moveCursorTo={this.moveCursorTo}
          {...this.state}
          {...this.props}
        />
      </StyledCalendarContainer>
    )
  }
}

export default Calendar



// WEBPACK FOOTER //
// ./src/artzu-ui/src/Calendar/index.js